export default __webpack_public_path__ + "s3.png";